import { render } from "./priceindex-form.vue?vue&type=template&id=7d6cf4a8&scoped=true"
import script from "./priceindex-form.vue?vue&type=script&lang=js"
export * from "./priceindex-form.vue?vue&type=script&lang=js"

import "./priceindex-form.vue?vue&type=style&index=0&id=7d6cf4a8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d6cf4a8"]])

export default __exports__